import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AddOrEditImageModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AddOrEditImageModalContainer" */
      './AddOrEditImageModalContainer'
    ),
  loading: LoadingModal,
});
